import React, { ReactNode } from 'react';

import Button from '@/src/components/common/Elements/Button/Button';
import { cn } from '@/src/util/ui';

type ActionButtonProps = {
  id?;
  className?: string;
  onClick: (...args: any[]) => any;
  disabled?: boolean;
  children?: ReactNode;
  buttonClassSettings?: {
    variant?: string;
    size?: string;
    weight?: string;
    position?: string;
    isActive?: boolean;
    activeStyles?: string;
  };
};

const ActionButton = ({
  id,
  className,
  onClick,
  disabled = false,
  children,
  ...otherProps
}: ActionButtonProps) => {
  return (
    <Button id={id} className={cn(className)} onClick={onClick} disabled={disabled} {...otherProps}>
      {children}
    </Button>
  );
};

export default ActionButton;
